import { render } from "./ballot-setup-card.vue?vue&type=template&id=6e74cbd2"
import script from "./ballot-setup-card.vue?vue&type=script&lang=js"
export * from "./ballot-setup-card.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__